import { defineStore } from 'pinia';

export const useVersionConflictStore = defineStore('versionConflict', {
  state: () => ({
    showModal: false,
  }),
  actions: {
    show() {
      this.showModal = true;
    },
    /**
     * Withdraws the reload prompt where the caller has a better account of what happened.
     *
     * Context: the shared interceptor raises this dialog on **every** 409 it sees, and it is
     * terminal by construction — `App.vue` renders it with no close button and `refreshPage` as its
     * only action. A bulk order's partial placement is also a 409, but children exist and the caller
     * routes the officer somewhere that explains it, so leaving an undismissable "someone else
     * changed this, reload" over that outcome is actively wrong (review, 2026-09-22).
     */
    hide() {
      this.showModal = false;
    },
  },
});
